import { render, staticRenderFns } from "./return-sale.vue?vue&type=template&id=2962f5e4&"
import script from "./return-sale.vue?vue&type=script&lang=js&"
export * from "./return-sale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports